import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { TokenService } from '../services/token.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private tokenService: TokenService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    // const token = this.tokenService.getRefreshToken();
    // const isValid = this.tokenService.isRefreshTokenValid();

    if(this.tokenService.isRefreshTokenValid() && this.tokenService.isEveportalJwtTokenValid()){
      return true;
    }else{
      return this.router.createUrlTree(['/login']);
    }
  }
}
